import script from "./Chat.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chat.vue?vue&type=script&setup=true&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=59504816&lang=css"

const __exports__ = script;

export default __exports__